import { Warning } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { type ReactElement } from 'react';

import { cservWorkflowStatus, type PlanungsinformationFromThemaRouter } from '../../../dtos';
import { formatDateRange } from '../../../utils';
import { content } from './TerminPlanungsstatusCard.content';

export const printPlanungszeitraum = (planungsinformation: PlanungsinformationFromThemaRouter): string => {
  const planungsbeginn = planungsinformation.planungszeitraum?.start ?? null;
  const planungsende = planungsinformation.planungszeitraum?.end ?? null;

  if (planungsbeginn === null || planungsende === null) {
    return content.noInfoAvailable;
  } else {
    return formatDateRange(planungsbeginn, planungsende, true);
  }
};

export const getWorkflowStatusWithTooltip = (planungsinformation: PlanungsinformationFromThemaRouter): ReactElement => {
  const workflowStatusOrUnknown = planungsinformation.cservWorkflowStatus;
  const inBearbeitung = planungsinformation.istInBearbeitungBeiProduktmanager;

  const cservWorkflowLabel: string = content.workflowStatusLabels[workflowStatusOrUnknown];
  let cservWorkflowTooltip: string;
  if (inBearbeitung && workflowStatusOrUnknown !== cservWorkflowStatus.Produktmanagement) {
    cservWorkflowTooltip = content.workflowStatusTooltips.inBearbeitung;
  } else {
    cservWorkflowTooltip = content.workflowStatusTooltips[workflowStatusOrUnknown];
  }

  return (
    <Tooltip title={cservWorkflowTooltip} disableInteractive arrow>
      <Box display="flex" alignItems="center" fontSize="14px">
        {cservWorkflowLabel}
        {inBearbeitung && <Warning sx={{ ml: 0.5 }} color="warning" />}
      </Box>
    </Tooltip>
  );
};

export const printTermineImPlanungsintervall = (planungsinformation: PlanungsinformationFromThemaRouter): string => {
  let print = '';

  const { termineImPlanungsintervallIst, termineImPlanungsintervallSoll } = planungsinformation;

  if (termineImPlanungsintervallIst === null) {
    print += content.noInfoAvailable;
  } else {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    print += termineImPlanungsintervallIst;
  }

  print += '/';

  if (termineImPlanungsintervallSoll === null) {
    print += content.noInfoAvailable;
  } else {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    print += termineImPlanungsintervallSoll;
  }

  return print;
};
